import { CreateElement, VNode, VueConstructor } from "vue";
import Vue from "vue";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import MessagePreview from "./MessagePreview.vue";
import MessagePreviewCall from "./MessagePreviewCall.vue";
import MessagePreviewServicePurchase from "./MessagePreviewServicePurchase.vue";
import MessagePreviewTip from "./MessagePreviewTip.vue";

export function getMessagePreview(message?: Message): VueConstructor<Vue> {
  if (message && Number(message.senderId) > 0) {
    return MessagePreview;
  }
  if (message?.details?.type === "tip") {
    return MessagePreviewTip;
  }
  if (message?.details?.type === "call") {
    return MessagePreviewCall;
  }
  if (message?.details?.type === "creator_service") {
    return MessagePreviewServicePurchase;
  }
  return Vue.extend({
    functional: true,
    render: (h: CreateElement): VNode => h(),
  });
}
